import React from 'react'
import { Heart, Code, Globe, Mail } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-custom py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* 品牌信息 */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-primary-400 to-accent-400 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">J</span>
              </div>
              <span className="text-xl font-bold">Jordan 乔丹</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              用技术连接世界，用代码改变生活。<br/>
              AI全栈工程师，世界探索者，学习新范式倡导者。
            </p>
            <div className="flex items-center gap-2 text-gray-400">
              <span>Made with</span>
              <Heart size={16} className="text-red-400" />
              <span>and</span>
              <Code size={16} className="text-blue-400" />
              <span>by Jordan</span>
            </div>
          </div>

          {/* 快速链接 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">快速链接</h3>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-400 hover:text-white transition-colors">关于我</a></li>
              <li><a href="#projects" className="text-gray-400 hover:text-white transition-colors">项目展示</a></li>
              <li><a href="#interests" className="text-gray-400 hover:text-white transition-colors">兴趣领域</a></li>
              <li><a href="#travel" className="text-gray-400 hover:text-white transition-colors">旅行足迹</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors">联系我</a></li>
            </ul>
          </div>

          {/* 我的项目 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">我的项目</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://sxyz.space/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  冥想社区工具
                </a>
              </li>
              <li>
                <a 
                  href="https://temple.polarjordan.xyz/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  东玄上香祈福
                </a>
              </li>
              <li>
                <a 
                  href="https://tarot.polarjordan.xyz/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  西玄塔罗占卜
                </a>
              </li>
              <li>
                <a 
                  href="https://campus.polarjordan.xyz/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  校园模拟游戏
                </a>
              </li>
              <li>
                <a 
                  href="https://polarjordan.online/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  电商交易平台
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 分割线 */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 Jordan 乔丹. All rights reserved.
            </div>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <Globe size={16} />
                <span>全球数字游民</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <Mail size={16} />
                <span>polartech_jordan@163.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 